import { render, staticRenderFns } from "./HowDoIInteractWithAMultisigContract.vue?vue&type=template&id=224de032&scoped=true&"
import script from "./HowDoIInteractWithAMultisigContract.vue?vue&type=script&lang=js&"
export * from "./HowDoIInteractWithAMultisigContract.vue?vue&type=script&lang=js&"
import style0 from "./HowDoIInteractWithAMultisigContract.vue?vue&type=style&index=0&id=224de032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224de032",
  null
  
)

export default component.exports